import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { OEM_API_PROVIDER } from './features/connect/infrastructure/providers/oem.provider';
import { VEHICLES_API_PROVIDER } from './features/connect/infrastructure/providers/vehicles.provider';
import { authInterceptor } from './infrastructure/interceptors/auth.interceptor';
import { TranslationsModule } from './infrastructure/translations/translations.module';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([authInterceptor])),
        importProvidersFrom(TranslationsModule),
        VEHICLES_API_PROVIDER,
        OEM_API_PROVIDER,
    ],
};
